function DDUMainPosition({value}) {
    return (
        <div className="flex flex-col items-center justify-center w-[33%]">
            <h2 className="flex items-center font-bold text-[25px] mt-[-5px]">{value.position}<span className="text-[#4b4a4a] text-[20px]">/{value["active-cars"]}</span></h2>
            <p className="uppercase text-[#4b4a4a] font-bold text-[11px] mt-[-5px]">Pos</p>
        </div>
    );
}

export default DDUMainPosition;